import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrlProvider } from './api-url.provider';
import { Invoice } from '../shared/models/invoice';

@Injectable({
  providedIn: 'root'
})
export class ImageService {
  constructor(
    private http: HttpClient,
    private apiUrlProvider: ApiUrlProvider) { 
    }

  showInvoiceImage(invoice: Invoice, whenDone){
    let imageUrl = `${this.apiUrlProvider.url}/Images/Invoice/${invoice.invoiceImageUrl}`;
    this.http
      .get(imageUrl, {responseType: 'blob'})
      .subscribe(res => {
        let objectUrl = window.URL.createObjectURL(res);
        let imageAnchor: HTMLAnchorElement = document.createElement("a");
        imageAnchor.href = objectUrl;
        imageAnchor.target = "_blank";
        imageAnchor.download = invoice.originalInvoiceFilename;
        imageAnchor.click();
        window.URL.revokeObjectURL(objectUrl);
      }, _ => {})
      .add(()=>{
        if (whenDone){
          whenDone();
        }
      });
      // .subscribe(res => {
      //   let objectUrl = window.URL.createObjectURL(res);
      //   window.open(objectUrl, "project_invoice");
      //   window.URL.revokeObjectURL(objectUrl);
      // });
  }
}
